import '../styles/PageGlobal.css';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TVAStateService } from '../services/TVAStateService.js';

export default function TVAStateNewPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({  label: '' });

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    if ( !form.label) {
      setError("Le code et le label sont requis.");
      return;
    }
    const service = new TVAStateService();
    setLoading(true);
    try {
      await service.createTVAState(form);
      alert("État TVA créé avec succès !");
      navigate("/tva-state-list");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="containerMain tva-new-container">
      <h1 className="tva-new-title">Créer un État / Pays TVA</h1>
      {error && <div className="tva-error">{error}</div>}

      <div className="tva-new-form" style={{ maxWidth: '500px' }}>
        
        <div className="tva-new-row">
          <label>Label / Pays (ex: France, DOM-TOM) *</label>
          <input type="text" name="label" value={form.label} onChange={handleChange} required />
        </div>
      </div>

      <div className="tva-new-footer">
        <button className="tva-btn tva-btn-blue" onClick={handleSave} disabled={loading}>{loading ? '...' : 'Enregistrer'}</button>
        <button className="tva-btn tva-btn-grey" onClick={() => navigate("/tva-state-list")} disabled={loading}>Annuler</button>
      </div>
    </div>
  );
}